module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226069807_04_pre#pre"
    }
  }, [_vm._v("Preface: A Botanist at Large")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226069807_05_ch1#ch1"
    }
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" A Green World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein a discussion of “plant” and “plant kingdom” introduces the science of taxonomy and classification, and the nature of science is illustrated by explaining how we know the age of the Earth and why biologists care about elements from stars and molecules from space")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226069807_06_ch2#ch2"
    }
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Small Green Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein the discovery of microorganisms, their amazing numbers, and the places they live are explored; evidence of ancient life is examined; and the nature of metabolisms and the origin of their complexity is explained")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_07_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Cellular Collaborations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein the diversity of unicellular organisms is explored, chloroplasts and mitochondria are obtained via symbiotic interactions between cells, and other features such as nuclei and sex are examined to determine what can be learned of their origins and functions")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_08_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" A Big Blue Marble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein algae are introduced, ocean ecology is explained, and phytoplankton diversity is explored")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_09_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Down by the Sea (-weeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein coastal environments are contrasted to oceanic environments, and organisms adapt to the new challenges presented by living on coasts by becoming anchored, larger, and multicellular, which in the case of green organisms results in those algae called seaweeds")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_10_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" The Great Invasion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein the challenges and colonization of the terrestrial environment are examined so as to understand the adaptations of land plants, especially their life cycle")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_11_ch7#ch7",
      "id": "page_vi",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7.")]), _vm._v(" The Pioneer Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein liverworts, hornworts, and mosses are examined to demonstrate their adaptations to terrestrial life and their relationships to each other and vascular plants")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_12_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8.")]), _vm._v(" Back to the Devonian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein a field trip to the Devonian introduces early vascular plants and examines how, from such small beginnings, xylem and new ways of branching helped plants produce leaves and roots and grow into trees, Earth’s first forests")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_13_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9.")]), _vm._v(" Seeds to Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein the nature of seeds, their impact on the land plant life cycle, their history, and the diversity of seed plants is investigated")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_14_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10.")]), _vm._v(" A Cretaceous Takeover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Wherein the quite singular ecological dominance and species diversity of the flowering plants are examined in light of their novel features and their gymnospermous ancestry")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_15_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11.")]), _vm._v(" All Flesh Is Grass")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('em', [_vm._v("Wherein the development of modern vegetation and recent interactions, like agriculture, and their impact on both plants and humans are examined")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_16_pos#pos",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_17_app#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_18_app1#app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Brown Algae and Tribophyceans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_19_app2#app2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Clubmosses and Fossil Stem Groups")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_20_app3#app3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Conifers and Ginkgoes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_21_app4#app4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Coniferophytes: Cordaitales and Voltziales")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_22_app5#app5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cycads")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_23_app6#app6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ferns")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_24_app7#app7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Gnetophytes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_25_app8#app8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Green Algae")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_26_app9#app9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Green Bacteria")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_27_app10#app10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Hornworts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_28_app11#app11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Horsetails")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_29_app12#app12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Liverworts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_30_app13#app13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Mosses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_31_app14#app14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Phytoplankton")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_32_app15#app15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Red Algae")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_33_app16#app16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rhyniophytes and Trimerophytes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_34_app17#app17",
      "id": "page_vii",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Seed Ferns")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_35_app18#app18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Whisk Ferns")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_36_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_37_glo#glo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_38_ref#ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226069807_39_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-731d22fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226069807_03_toc.vue
// module id = 63
// module chunks = 0